import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import styles from './styles.module.scss';
const { card, card_content, card_image, heading, author_name, loading_placeholder } = styles;

// ---------------------------------------------------------

const LifestyleCard = ({ linkUrl, headline, authorName, theme, featuredImage }) => {
  const [image, setImage] = useState(featuredImage);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    if (!image) {
      fetch(
        `https://api.embedly.com/1/extract?meta_images=true&url=${linkUrl}&key=${process.env.NEXT_PUBLIC_EMBEDLY}`
      )
        .then((response) => response.json())
        .then((data) => {
          setImage(data.images[0].url);
        })
        .catch((err) => {
          console.log(err);
          setImage(
            'https://images.ctfassets.net/wzzep3ntdgx4/4V3cWpoV2LctBsJYc6SnSf/4ef45ecd14a78222b508078d9fe9d345/AdobeStock_376819599.jpeg'
          );
        });
    }
  }, []);

  return (
    <a href={linkUrl} target="_blank" className={card} rel="noreferrer">
      <div className={card_image}>
        <img alt={headline} src={image} onLoad={() => setIsLoaded(true)}></img>
        {!isLoaded && <div className={loading_placeholder}></div>}
      </div>
      <div className={card_content}>
        <span className={heading}>{headline}</span>
        {authorName && (
          <span className={author_name}>
            {theme === 'Haus & Home' && 'By '}
            {authorName}
          </span>
        )}
      </div>
    </a>
  );
};

LifestyleCard.propTypes = {
  /**
   * Specifies the author of the content
   */
  authorName: PropTypes.string,

  /**
   * Specifies the Community Page Featured Image - receives a default image if none
   */
  featuredImage: PropTypes.string,

  /**
   * Specifies the headline
   */
  headline: PropTypes.string,

  /**
   * Specifies the link url
   */
  linkUrl: PropTypes.string,

  /**
   * Specifies the records theme
   */
  theme: PropTypes.string
};

export default LifestyleCard;
